import { setConfig } from '@faustwp/core';

import templates from './src/wp-templates';
import possibleTypes from './possibleTypes.json';

// eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
export default setConfig({
  plugins: [],
  possibleTypes,
  templates,
  useGETForQueries: false,
});
